'use strict';
var globalThis = require('../internals/global-this');

module.exports = globalThis;



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/path.js
// module id = 216
// module chunks = 0